"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitRewardedPopup = exports.SetPremiumIsActive = exports.boosterDurationSeconds = exports.PremiumIsActive = void 0;
var enums_1 = require("./enums");
var time_1 = require("./lib/time");
var shop_1 = require("./shop");
exports.PremiumIsActive = false;
var popup = document.querySelector("#double-reward-popup");
var errorText = document.querySelector("#double-reward-popup-error");
var showRewardedPopupButton = document.querySelector("#reward-popup-open-button");
var boosterTimerContainer = document.querySelector("#booster-timer-container");
var boosterTimer = document.querySelector("#booster-timer");
var buttonDelayOnStart = 0.5 * 60 * 1000; // on game start
var buttonDelayAfterVideo = 2 * 60 * 1000; // after watching video/closing modal
exports.boosterDurationSeconds = 60;
var adStarted = function () { };
var adFinished = function () {
    StartBooster();
};
var adError = function () {
    errorText.style.display = "block";
};
var ShowRewardedButton = function () {
    showRewardedPopupButton.style.display = "block";
};
var HideRewardedButton = function () {
    showRewardedPopupButton.style.display = "none";
};
var ShowRewardedPopup = function () {
    popup.style.display = "flex";
    errorText.style.display = "none";
};
var CloseRewardedPopup = function () {
    popup.style.display = "none";
};
var OnCloseClick = function () {
    CloseRewardedPopup();
    HideRewardedButton();
    setTimeout(ShowRewardedButton, buttonDelayAfterVideo);
};
var OnWatchVideoClick = function () {
    var callbacks = {
        adFinished: function () {
            console.log("End rewarded ad (callback)");
            adFinished();
        },
        adError: function (error) {
            console.log("Error rewarded ad (callback)", error);
            adError();
        },
        adStarted: function () {
            console.log("Start rewarded ad (callback)");
            adStarted();
        },
    };
    window.CrazyGames.SDK.ad.requestAd("rewarded", callbacks);
};
var StartBooster = function () {
    CloseRewardedPopup();
    HideRewardedButton();
    exports.PremiumIsActive = true;
    (0, shop_1.RefreshShopItem)(enums_1.ITEM.MoneyPerBrick);
    (0, shop_1.RefreshShopItem)(enums_1.ITEM.BricksPerClick);
    boosterTimerContainer.style.display = "flex";
    var duration = exports.boosterDurationSeconds;
    boosterTimer.innerHTML = (0, time_1.msToMMSS)(duration * 1000);
    var intervalId = setInterval(function () {
        duration--;
        boosterTimer.innerHTML = (0, time_1.msToMMSS)(duration * 1000);
        if (duration <= 0) {
            clearInterval(intervalId);
            StopBooster();
        }
    }, 1000);
};
var StopBooster = function () {
    exports.PremiumIsActive = false;
    (0, shop_1.RefreshShopItem)(enums_1.ITEM.MoneyPerBrick);
    (0, shop_1.RefreshShopItem)(enums_1.ITEM.BricksPerClick);
    boosterTimerContainer.style.display = "none";
    setTimeout(ShowRewardedButton, buttonDelayAfterVideo);
};
var SetPremiumIsActive = function (isActive) {
    exports.PremiumIsActive = isActive;
};
exports.SetPremiumIsActive = SetPremiumIsActive;
var InitRewardedPopup = function () {
    showRewardedPopupButton.addEventListener("click", ShowRewardedPopup);
    document.querySelector("#double-reward-popup-close-button").addEventListener("click", OnCloseClick);
    document.querySelector("#double-reward-popup-watch-button").addEventListener("click", OnWatchVideoClick);
};
exports.InitRewardedPopup = InitRewardedPopup;
setTimeout(ShowRewardedButton, buttonDelayOnStart);
